/**
 * GigPiece_Entity type guard.
 *
 * @param {any} gigPieceJson GigPiece object from API
 * @returns {boolean} Return true if type is GigPiece_Entity
 */
function validator(gigPieceJson: unknown): gigPieceJson is GigPiece_Entity {
  if (typeof gigPieceJson === "object" && gigPieceJson != null) {
    GigPiece_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(gigPieceJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class GigPiece_Entity {
  static requiredFields = [
    "id",
    "memberID",
    "gigID",
    "title",
    "composer",
    "position",
    "sectionOrder",
    "sectionRoleID",
    "sectionID",
    "instrumentIDs",
    "memo",
    "librarianPieceID",
    "sourceID",
    "sourceRecordID",
    "createdAt",
    "updatedAt",
  ];

  constructor(gigPieceJson: unknown) {
    if (validator(gigPieceJson)) {
      this.id = gigPieceJson.id;
      this.memberID = gigPieceJson.memberID;
      this.gigID = gigPieceJson.gigID;
      this.title = gigPieceJson.title;
      this.composer = gigPieceJson.composer;
      this.position = gigPieceJson.position;
      this.sectionOrder = gigPieceJson.sectionOrder;
      this.sectionRoleID = gigPieceJson.sectionRoleID;
      this.sectionID = gigPieceJson.sectionID;
      this.instrumentIDs = gigPieceJson.instrumentIDs;
      this.memo = gigPieceJson.memo;
      this.librarianPieceID = gigPieceJson.librarianPieceID;
      this.sourceID = gigPieceJson.sourceID;
      this.sourceRecordID = gigPieceJson.sourceRecordID;
      this.createdAt = gigPieceJson.createdAt;
      this.updatedAt = gigPieceJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ GigPiece_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  memberID: number;
  gigID: number;
  title: string;
  composer: string;
  position: number;
  sectionOrder: number;
  sectionRoleID: number;
  sectionID: number;
  instrumentIDs: string;
  memo: string;
  librarianPieceID: number;
  sourceID: number;
  sourceRecordID: number;
  createdAt: string;
  updatedAt: string;
}
